'use client';

import { useEffect } from 'react';

export function SearchParams({ searchParams, referrer }) {
	// const params = useSearchParams();

	useEffect(() => {
		const { refId } = searchParams;

		const { sourceId } = searchParams;
		// const referrer = document.referrer.split('https://').join('').split('http://').join('').split('/')[0];

		if (referrer) {
			sessionStorage.setItem('referrer', referrer.split('https://').join('').split('http://').join('')
				.split('/')[0]);
		}
		if (refId) {
			sessionStorage.setItem('refId', refId);
		}
		if (sourceId) {
			sessionStorage.setItem('sourceId', sourceId);
		}
	}, []);

	return null;
}
